export class PushRepository {
  constructor(client) {
    this.client = client;
    this.basePath = '/api/push';
  }

  getConfig() { return this.client.get(`${this.basePath}/config`); }
  list() { return this.client.get(`${this.basePath}/subscriptions`); }
  register(subscription) { return this.client.post(`${this.basePath}/subscriptions`, subscription); }
  update(id, subscription) {
    return this.client.put(`${this.basePath}/subscriptions/${encodeURIComponent(id)}`, subscription);
  }
  delete(id) { return this.client.delete(`${this.basePath}/subscriptions/${encodeURIComponent(id)}`); }
}
